export default __webpack_public_path__ + "static/media/jeu.50aeecd1.png";